<template>
  <div>
    <div class="lg:flex md:flex gap-5 lg:px-10 md:px-8 px-5 mb-5">
      <div class="lg:w-2/3 md:w-2/3 mt-28">
        <b-card class="shadow-lg">
          <Profiledata />
          <Tabs />
        </b-card>
      </div>
      <div class="lg:w-1/3 md:w-1/3 lg:mt-28 md:mt-28 mt-6">
        <b-card class="shadow-lg">
          <Searchbar />
          <template v-if="$route.query.location">
            <Listview />
          </template>
          <template v-if="$route.query.service">
            <ServiceProviderList />
          </template>
        </b-card>
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Searchbar from "./components/Searchbar.vue";
import Footer from "../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
import Profiledata from "./components/Profiledata.vue";
import Tabs from "./components/Tabs.vue";
import Listview from "./components/Listview.vue";
import ServiceProviderList from "./components/ServiceProviderList.vue";
import { mapState } from "vuex";

export default {
  components: {
    Searchbar,
    Profiledata,
    Tabs,
    Footer,
    DownloadApp,
    Listview,
    ServiceProviderList,
  },
  computed: {
    ...mapState("services", { get_AllService: "get_AllService" }),
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
  },
  async mounted() {
    await this.$store.dispatch("services/get_all");
    await this.$store.dispatch("auth/getUserByUserId", {
      userId: this.user._id,
    });
    await this.$store.dispatch("subscribe/GetAllMembership");
    this.get_AllService.result.forEach((ele) => {
      if (ele.title === this.$route.query.service) {
        let membershipDisc = ele.membershipDisc;
        this.$store.commit("respitecare/SERVICE_DISCOUNT", membershipDisc);
      }
    });
  },
};
</script>

<style>
@media (max-width: 641px) {
  .card-body {
    padding: 5px;
  }
}
</style>
